<template>
  <div class="row pt-3">
    <div class="col-lg-8 col-md-12 col-sm-12" :class="blur()">
      <div class="row">
        <div class="profile-page">
          <div class="rounded-3" :class="network.is_cover_visible ? 'profile-header' : ''">
            <div class="cover">
              <div class="rounded-3"></div>
              <div v-if="network.is_cover_visible" class="row rounded-3 rounded-top-0 bg-primary bg-opacity-50 h-25 p-sm-0" style="position: absolute; width: 100%; bottom: 0;">
                <!--Desktop-->
                <div class="d-none d-sm-block">
                  <div class="col-xl-3 col-lg-4 col-md-4">
                    <avatar
                      :size="150"
                      :username="network.short_name"
                      :src="network.logo_url"
                      class="profile-pic rounded-circle ms-5 bg-gradient-primary-dark"
                      style="margin-top: -5rem;"
                    ></avatar>
                  </div>
                  <div class="col-xl-9 col-lg-8 col-md-8 mt-n5" style="margin-left: 15rem;">
                    <strong class="text-white display-6">{{ network.name }}</strong>
                  </div>
                </div>
                <!--Mobile-->
                <div class="d-block d-sm-none">
                  <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <avatar
                      :size="55"
                      :username="network.short_name"
                      :src="network.logo_url"
                      class="profile-pic rounded-circle bg-gradient-primary-dark"
                      style="margin-top: -2rem; font-size: 20px;"
                    ></avatar>
                  </div>
                  <div class="col-xl-9 col-lg-8 col-md-8 col-sm-12 col-xs-12 pt-n6" style="margin-left: 4rem; margin-top: -1.1rem;">
                    <strong class="text-white">{{ network.short_name }}</strong>
                  </div>
                </div>
              </div>
              <div v-else class="row" style="position: absolute; width: 100%;">
                <!--Desktop-->
                <div class="d-none d-sm-block">
                  <div class="col-xl-3 col-lg-4 col-md-4">
                    <avatar
                      :size="150"
                      :username="network.short_name"
                      :src="network.logo_url"
                      class="profile-pic rounded-circle bg-gradient-primary-dark"
                      style="margin-top: 0.4rem;"
                    >
                    </avatar>
                  </div>
                  <div class="col-xl-6 col-lg-5 col-md-8" style="margin: -9rem 0 0 12rem">
                    <span class="'text-secondary fw-bold display-6">{{ network.short_name }}</span><br />
                    <p :style="{'font-size': network.purpose.length >= 300 ? '12px' : 'inherit'}" style="margin-bottom: 0 !important;">
                      {{ network.purpose }}
                    </p>
                  </div>
                </div>
                <!--Mobile-->
                <div class="d-block d-sm-none">
                  <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <avatar
                      :size="55"
                      :username="network.short_name"
                      :src="network.logo_url"
                      class="profile-pic rounded-circle bg-gradient-primary-dark"
                      style="margin-top: -3rem; font-size: 20px;"
                    ></avatar>
                  </div>
                  <div class="col-xl-9 col-lg-8 col-md-8 col-sm-12 col-xs-12 pt-n6" style="margin-left: 4.5rem; margin-top: -2.5rem;">
                    <strong class="text-secondary fs-4">{{ network.short_name }}</strong>
                  </div>
                </div>
              </div>
              <figure v-if="network.is_cover_visible" style="margin: 0;">
                <!--Desktop-->
                <div class="d-none d-sm-block">
                  <img
                    v-if="!network.cover_url"
                    src="@/assets/img/networks-home-default-banner.jpeg"
                    :alt="this.$t('Home.default-profile-cover')"
                    class="img-fluid rounded-3 bg-white"
                    style="height: 30rem;"
                  />
                  <img v-else :src="network.cover_url" :alt="this.$t('Home.profile-cover')" class="img-fluid rounded-3 bg-white" style="height: 30rem;" />
                </div>
                <!--Mobile-->
                <div class="d-block d-sm-none">
                  <img
                    v-if="!network.cover_url"
                    src="@/assets/img/networks-home-default-banner.jpeg"
                    :alt="this.$t('Home.default-profile-cover')"
                    class="img-fluid rounded-3 bg-white"
                  />
                  <img v-else :src="network.cover_url" :alt="this.$t('Home.profile-cover')" class="img-fluid rounded-3 bg-white" />
                </div>
              </figure>
              <figure v-else class="mb-n2">
                <!--Desktop-->
                <div class="d-none d-sm-block" style="height: 10rem;"></div>
                <!--Mobile-->
                <div class="d-block d-sm-none mb-1" style="height: 1rem; margin-top: 3.5rem;"></div>
              </figure>
            </div>
          </div>
          <div
            v-if="$auth.auth && isMember && notification_events()"
            class="col-lg-12 col-xl-12 col-sm-12 rounded-2 d-none d-sm-block"
            :class="network.is_cover_visible ? 'mt-3' : (network.purpose.length >= 250 ? 'mt-5' : 'mt-3')"
            style="background: #d9d9d9; padding: 13px; font-size: 13px;"
          >
            <b style="font-size: 13px;">
              {{ notification_events() }}
              <router-link :to="'/profile/edit#notifications'" class="float-end">
                {{ $t('set-now') }}
              </router-link>
            </b>
          </div>
        </div>
      </div>

      <div class="row mobile-icons"
      :class="[blur(), network.purpose.length >= 250 ? ($auth.auth && isMember && notification_events() ? 'mt-3' : 'mt-5') : 'mt-5']">
      <!--Desktop-->
        <div class="col-3 fs-4 p-3 d-none d-lg-block">
          <router-link :to="'/networks/' + network.slug + '/members'" style="text-decoration: none; display: flex;">
            <i class="fa fa-users fa-2x"></i>
            <span class="ps-2 pt-2">{{ network.members_count }} {{ $t('network.tabMembers') }}</span>
          </router-link>
        </div>
        <div class="col-3 fs-4 p-3 d-none d-lg-block">
          <router-link :to="'/networks/' + network.slug + '/media'" style="text-decoration: none; display: flex;">
            <i class="fa fa-list-ol fa-2x"></i>
            <span class="ps-2 pt-2">{{ network.media_count }} {{ $t('network.items') }}</span>
          </router-link>
        </div>
        <div class="col-3 fs-4 p-3 d-none d-lg-block">
          <Fav :loading="busy" :value="is_liked" :homepageD="true" @input="toggleLike" />
        </div>
        <div v-if="network.can.update" class="col-3 fs-4 p-3 d-none d-lg-block">
          <router-link :to="'/networks/' + network.slug + '/edit'" style="text-decoration: none; display: flex;">
            <i class="fas fa-pen-to-square fa-2x"></i>
            <span class="ps-2 pt-2">{{ $t('network.editNetwork') }}</span>
          </router-link>
        </div>
        <!--Mobile & tablet-->
        <div class="col fs-5 p-1 ps-3 d-lg-none d-xl-none">
          <router-link :to="'/networks/' + network.slug + '/members'" style="text-decoration: none;">
            <i class="fa fa-users"></i>
            <span class="ps-1 pt-0">{{ network.members_count }}</span>
          </router-link>
        </div>
        <div class="col fs-5 p-1 ps-3 d-lg-none d-xl-none">
          <router-link :to="'/networks/' + network.slug + '/media'" style="text-decoration: none;">
            <i class="fa fa-list-ol"></i>
            <span class="ps-1 pt-0">{{ network.media_count }}</span>
          </router-link>
        </div>
        <div class="col fs-5 p-1 d-lg-none d-xl-none text-center">
          <Fav :loading="busy" :value="is_liked" :homepageM="true" @input="toggleLike" />
        </div>
        <div v-if="network.can.update" class="col fs-5 p-1 ps-3 d-lg-none d-xl-none text-end">
          <router-link :to="'/networks/' + network.slug + '/edit'" style="text-decoration: none;">
            <i class="fas fa-pen-to-square"></i>
          </router-link>
        </div>
        <div class="col fs-5 p-1 pe-3 d-lg-none d-xl-none text-end">
          <a style="text-decoration: none;" @click="showUpdatesModal = !showUpdatesModal">
            <i class="fas fa-bell" style="transform: rotate(-14deg); color: #005f9a"></i>
          </a>
        </div>
      </div>

      <div v-if="network.about" class="row mt-2" :class="blur()">
        <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px); margin: 20px 0px;">
        <div v-html="network.about"></div>
        <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px); margin: 20px 0px;">
      </div>

      <div v-if="featuredMembers && featuredMembers.length > 0 && $auth.auth && network.is_mine" class="row my-3">
        <h4 class="fw-bold">{{ $t('core-contributors') }}</h4>

        <div v-for="member in featuredMembers" :key="member.id" class="col-xl-3 col-lg-4 col-md-6 col-sm-6 pb-2 d-none d-sm-block">
          <div class="card text-center">
            <div class="card-body">
              <h5 class="card-title">
                <img
                  :src="member.profile_image_url || '/img/user.png'"
                  :alt="member.first_name + ' ' + member.last_name"
                  class="rounded-circle"
                  style="width: 100px !important; height: 100px !important;"
                />
              </h5>
              <p class="card-text pt-2">{{ member.first_name + ' ' + member.last_name }}</p>
            </div>
            <div class="card-footer text-white bg-primary">{{ member.network_user.role_name | upperCase }}</div>
          </div>
        </div>
        <div class="col-md-12 mt-4 d-none d-sm-block">
          <router-link :to="'/networks/' + network.slug + '/members/'">
            <button id="view_all" data-test="view_all" class="btn btn-primary btn-sm">{{ $t('network.viewAll') }}</button>
          </router-link>
        </div>
        <Flicking :options="{ align: 'next', circular: true, panelsPerView: 2 }" class="d-block d-sm-none">
          <div v-for="member in featuredMembers" :key="member.id">
            <div class="panel ps-1 pe-1">
              <div class="card text-center">
                <div class="card-body">
                  <h5 class="card-title">
                    <img
                      :src="member.profile_image_url || '/img/user.png'"
                      :alt="member.first_name + ' ' + member.last_name"
                      class="rounded-circle"
                      style="width: 100px !important; height: 100px !important;"
                    />
                  </h5>
                  <p class="card-text pt-2">{{ member.first_name + ' ' + member.last_name }}</p>
                </div>
                <div class="card-footer text-white bg-primary">{{ member.network_user.role_name | upperCase }}</div>
              </div>
            </div>
          </div>
        </Flicking>
      </div>
    </div>
    <div class="col-md-12 col-lg-4 col-sm-12 col-xs-12" :class="blur()">
      <div class="row mb-4 d-none d-lg-block">
        <div style="padding-left: 0.75rem;">
          <h3 class="fw-bold" style="color: #5c6d80; cursor: default;">{{ $t('network.updates') }}</h3>
          <div class="clearfix"></div>
        </div>
        <div v-if="!network.is_mine && network.moderation">
          <span>{{ $t('apply-for-membership-to-access-the-latest-updates') }}</span>
        </div>
        <div v-else>
          <div v-if="network_notifications && network_notifications.length > 0">
            <table class="table border-bottom">
              <tbody id="message-list">
                <tr v-for="(notification, index) in network_notifications.slice(0, 5)" id="item-message-1" :key="index" style="border-style: hidden;">
                  <td>
                    <div class="row" @click.prevent="openAndRemove(notification)">
                      <div class="card" style="box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2); cursor: pointer; padding: 4px;">
                        <div class="card-body p-3 fs-sm">
                          <div class="text-heading">
                            <div class="fw-semibold">
                              {{ notification.title }}
                              <i class="float-end" :class="notification.icon + ' fa-2x'" :style="{ color: notificationColor(notification.icon) }"></i>
                            </div>
                          </div>
                          <div v-if="notification.icon != 'fas fa-comment'" class="pt-1 pb-2 text-heading card-text">
                            <div v-html="showableText(notification.message)"></div>
                          </div>
                          <div v-else class="pt-1 pb-2 text-heading card-text mb-n4">
                            <div v-html="showableText(notification.message)"></div>
                          </div>
                          <div class="ms-sm-auto text-muted fs-xs">{{ getTimeFromNow(notification.created_at) }}</div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style="padding-left: 0.75rem;">
              <button
                v-if="$auth.auth"
                id="view_all"
                data-test="view_all"
                style="padding: 8px 32px;"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasNotification"
                aria-controls="offcanvasNotification"
                class="btn btn-outline-primary"
              >
                {{ $t('network.viewAll') }}
              </button>
            </div>
          </div>
          <div v-else>
            <div class="alert alert-info mt-2">
              {{ $t('networks.notifications.noNotificationsFound') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h3 class="fw-bold mb-0" style="color: #5c6d80; cursor: default;">{{ $t('network.recentlyPublished') }}</h3>
        </div>
        <div v-if="media && media.length > 0">
          <div class="col-md-4" align="right"></div>
          <div class="col-md-12 p-0">
            <NetworkFeed
              :network="network"
              :columns="2"
              :limit="4"
              :disableInfinityScroll="true"
              :showSidebar="false"
              displaySize="small"
              :search-bar="false"
              :noLayout="true"
            />
          </div>
        </div>
        <div v-else>
          <div class="alert alert-info mt-2">
            {{ $t('network.noMediaToShow') }}
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showNotificationsModal" hide-footer hide-header size="lg">
      <span><b>{{ $t('set-the-choices-for-notifications-you-wish-to-receive-in-broadcast-and-email') }}</b></span>
      <NetworkNotifications :currentNetwork="network" />
      <span>
        <b>{{ $t('want-to-set-notification-choices-for-other-networks') }}</b>&nbsp;
        <router-link :to="'/profile'" style="text-decoration: none;">
          <b>{{ $t('go-to-profile') }}</b>
        </router-link>
      </span>
    </b-modal>
    <b-modal v-model="showUpdatesModal" hide-footer size="lg">
      <div v-if="network_notifications && network_notifications.length > 0" class="row mb-4">
        <div style="padding-left: 0.75rem;">
          <h3 class="fw-bold" style="color: #5c6d80; cursor: default;">{{ $t('network.updates') }}</h3>
          <div class="clearfix"></div>
        </div>
        <table class="table border-bottom">
          <tbody id="message-list">
            <tr v-for="(notification, index) in network_notifications.slice(0, 3)" id="item-message-1" :key="index" style="border-style: hidden;">
              <td>
                <div class="row" @click.prevent="openAndRemove(notification)">
                  <div class="card" style="box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2); cursor: pointer; padding: 4px;">
                    <div class="card-body p-3 fs-sm">
                      <div class="text-heading">
                        <div class="fw-semibold">
                          {{ notification.title }}
                          <i :class="notification.icon + ' fa-2x'" class="float-end" :style="{ color: notificationColor(notification.icon) }"></i>
                        </div>
                      </div>
                      <div v-if="notification.icon != 'fas fa-comment'" class="pt-1 pb-2 text-heading card-text">
                        <div v-html="showableText(notification.message)"></div>
                      </div>
                      <div v-else class="pt-1 pb-2 text-heading card-text mb-n4">
                        <div v-html="showableText(notification.message)"></div>
                      </div>
                      <div class="ms-sm-auto text-muted fs-xs">{{ getTimeFromNow(notification.created_at) }}</div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div style="padding-left: 0.75rem;">
          <button
            v-if="$auth.auth"
            id="view_all"
            data-test="view_all"
            style="padding: 8px 32px;"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNotification"
            aria-controls="offcanvasNotification"
            class="btn btn-primary"
          >
            {{ $t('network.viewAll') }}
          </button>
        </div>
      </div>
      <div v-else>
        <span>{{ $t('you-have-0-notifications') }}</span>
      </div>
    </b-modal>
    <JoinNetworkCard :show="showJoinCard" :network="network" :instance="instance" />
  </div>
</template>
<script>
//import MessageCard from '@/views/networks/messages/Card';
import NetworkFeed from '@/views/networks/media/feed/';
import NetworkService from '@/services/NetworkService.js';
import JoinNetworkCard from '../../components/commons/Networks/JoinNetworkCard.vue';
const NetworkNotifications = () => import('../user/NetworkNotifications.vue');
import { mapState } from 'vuex';
import { truncate, orderBy } from 'lodash';
import Avatar from 'vue-avatar';
import Fav from '@/components/Fav';
import Flicking from '@egjs/vue-flicking';
import '@egjs/vue-flicking/dist/flicking.css';
import moment from 'moment-timezone';
//import myUpload from 'vue-image-crop-upload/upload-2.vue';
import Vue from 'vue';
import queryString from 'query-string';

Vue.use(Flicking);

export default {
  components: {
    Avatar,
    Fav,
    NetworkFeed,
    JoinNetworkCard,
    //'my-upload': myUpload,
    NetworkNotifications,
  },
  filters: {
    upperCase(value) {
      return value.toUpperCase();
    },
  },
  props: {
    network: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busy: false,
      featuredMembers: null,
      industryMembers: null,
      media: null,
      messages: null,
      defaultBanner: './assets/img/networks-home-default-banner.jpeg',
      show_profile_upload_modal: false,
      show_cover_upload_modal: false,
      isMember: false,
      showNotificationsModal: false,
      filteredNotifications: [],
      my_networks: [],
      all_network_events: [],
      my_managed_networks: [],
      managed_network_events: [],
      other_events: [],
      notificationPreferences: [],
      showUpdatesModal: false,
      showJoinCard: false,
      instance: '',
      is_liked: this.network.is_liked,
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      notifications: state => state.notifications.notifications,
    }),
    network_notifications() {
      this.notifications.forEach(element => {
        if (element.network && element.network == this.network.slug) {
          element.position = this.notifications.indexOf(element);
          this.filteredNotifications.push(element);
        }
      });
      return orderBy(this.filteredNotifications, 'created_at', 'desc');
    },
    canJoin() {
      return !this.network.is_mine && this.network.public;
    },
    env() {
      return process.env.VUE_APP_ENV;
    },
    //Returns the combined version of the oauth login URL
    signin_url() {
      let query = queryString.stringify({
        client_id: process.env.VUE_APP_OAUTH_SERVER_ID,
        redirect_uri: process.env.VUE_APP_OAUTH_SERVER_REDIRECT_URI,
        response_type: 'code',
      });
      return process.env.VUE_APP_OAUTH_SERVER_URI + '/oauth/authorize?' + query;
    },
    signup_url() {
      let query = queryString.stringify({
        client_id: process.env.VUE_APP_OAUTH_SERVER_ID,
        redirect_uri: process.env.VUE_APP_OAUTH_SERVER_REDIRECT_URI,
        response_type: 'code',
        register: 'true',
        email: this.registrationEmail,
      });
      return process.env.VUE_APP_OAUTH_SERVER_URI + '/oauth/authorize?' + query;
    },
  },
  watch: {
    showJoinCard(newVal) {
      if (newVal == true) {
        this.$store.dispatch('setNextURL', this.$route.fullPath);
      }
    },
  },
  mounted() {
    this.$http.get('/networks/' + this.network.slug + '/about').then(resp => {
      this.featuredMembers = resp.data.featured_members;
      this.industryMembers = resp.data.industry_members;
      this.media = resp.data.media;
      this.messages = resp.data.messages;
    });
    if (this.$auth.auth) {
      this.$http.get('/networks/' + this.network.slug + '/members').then(resp => {
        let members = resp.data.data;
        for (let index = 0; index < members.length; index++) {
          if (members[index]['email'] == this.$store.getters['user']['email']) {
            this.isMember = true;
            break;
          }
        }
      });
    }
    if (this.$auth.auth) {
      if (this.network.is_mine) {
        // for users who are members of this network
        this.$http.get('notification-events').then(resp => {
          this.my_networks = resp.data.my_networks;
          this.all_network_events = resp.data.all_network_events;

          this.$http.get('/auth/notification-preferences').then(resp => {
            this.my_networks.forEach(network => {
              this.all_network_events.forEach(e => this.loadPreferenceFromEvent(resp.data, e, network.id));
            });
            this.my_managed_networks.forEach(network => {
              this.managed_network_events.forEach(e => this.loadPreferenceFromEvent(resp.data, e, network.id));
            });
            this.other_events.forEach(e => this.loadPreferenceFromEvent(resp.data, e));
          });
        });
      } else {
        // cards will only show up for non super admins
        if (!this.$auth.hasRole('super-admin')) {
          if (this.network.public) {
            if (this.network.moderation) {
              // public and moderated network
              if (this.network.industry_membership_expired) {
                // for user whose membership has expired
                this.instance = 'showIndustryMembershipExpiredModal';
                this.showJoinCard = true;
              } else if (this.network.is_in_moderation_queue) {
                // for users who have applied to join the moderated network
                if (this.network.join_status != 'REJECTED') {
                  // for users who have applied to join the moderated network (pending status)
                  this.instance = 'showPendingModerationModal';
                  this.showJoinCard = true;
                } else if (this.network.join_status == 'REJECTED') {
                  // for users who have applied to join the moderated network (rejected status)
                  this.instance = 'showRejectedModerationModal';
                  this.showJoinCard = true;
                }
              } else if (this.network.is_in_industry_moderation_queue) {
                // for industry users who have applied to join the moderated network
                if (this.network.industry_join_status != 'REJECTED') {
                  // for industry users who have applied to join the moderated network (pending status)
                  this.instance = 'showIndustryPendingModerationModal';
                  this.showJoinCard = true;
                } else if (this.network.industry_join_status == 'REJECTED') {
                  // for industry users who have applied to join the moderated network (rejected status)
                  this.instance = 'showIndustryRejectedModerationModal';
                  this.showJoinCard = true;
                }
              } else {
                // public and non moderated network - for users who haven't applied to join
                this.instance = 'showModerationModal';
                this.showJoinCard = true;
              }
            } else {
              // public and non moderated network
              this.instance = 'showPublicJoinModal';
              this.showJoinCard = true;
            }
          } else {
            // private network
            this.instance = 'showPrivateModal';
            this.showJoinCard = true;
          }
        }
      }
    } else {
      // this.$bus.emit('show-sign-in'); → default login modal
      // for logged out users
      this.instance = 'showLoggedOutModal';
      this.showJoinCard = true;
    }
  },
  methods: {
    blur() {
      if (!this.$auth.auth) {
        return 'blur';
      } else if (!this.network.is_mine && !this.network.public && !this.$auth.hasRole('super-admin')) {
        return 'blur';
      } else {
        return '';
      }
    },
    getFileNameFromUrl(url) {
      return url.substring(url.lastIndexOf('/') + 1);
    },
    toggleProfileImageModal() {
      this.show_profile_upload_modal = !this.show_profile_upload_modal;
    },
    toggleCoverImageModal() {
      this.show_cover_upload_modal = !this.show_cover_upload_modal;
    },
    uploadProfileImage(imgDataUrl) {
      console.log(imgDataUrl);
      this.$http.post('networks/upload-logo/' + this.network.slug, { network_logo: imgDataUrl, network_slug: this.network.slug }).then(resp => {
        this.show_profile_upload_modal = false;
        this.network.logo_url = resp.data.filename;
        location.reload();
      });
    },
    uploadCoverImage(imgDataUrl) {
      this.$http.post('networks/upload-cover/' + this.network.slug, { network_cover: imgDataUrl, network_slug: this.network.slug }).then(resp => {
        this.show_cover_upload_modal = false;
        this.network.cover_url = resp.data.filename;
        location.reload();
      });
    },
    deleteImage(field, image_path) {
      this.$swal.fire({
        title: this.$t('NetworkForm.are-you-sure-you-want-to-delete-this-image'),
        input: 'text',
        inputLabel: this.$t('Showtype-delete-to-proceed'),
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-danger mx-1',
          cancelButton: 'btn btn-primary mx-1',
        },
        inputValidator: (value) => {
          if (!value) {
            return this.$t('you-need-to-write-something')
          }
          if (value != 'DELETE') {
            return this.$t('wrong-input')
          }
          if (value === 'DELETE') {
            let network_slug = this.network.slug;
            NetworkService.deleteImage(network_slug, field, image_path).then(res => {
              if (res.status == 200) {
                var field = res.data.field.replaceAll('_', ' ').charAt(0).toUpperCase() + res.data.field.replaceAll('_', ' ').slice(1);
                let message = this.$t('network.edit.media-deleted', {
                  defaultValue: ' {{ field }} deleted successfully',
                  replace: { field },
                });

                this.$swal
                  .fire({
                    icon: 'success',
                    title: this.$t('success'),
                    text: message,
                  })
                  .then(function () {
                    location.reload();
                  });
              }
            });
          }
        }
      });
    },
    showableText(content) {
      let limit = this.character_limit || 150;
      return truncate(content, {
        length: limit,
        separator: /,?\.* +/, // separate by spaces, including preceding commas and periods
      });
    },
    getTimeFromNow(time) {
      return moment.utc(time).local().fromNow();
    },
    openAndRemove(notification) {
      // this removes the notification from network dashboard and broadcast menu
      //this.$store.dispatch('notifications/removeNotification', notification.position);
      if (notification.button.type && notification.button.type === 'external') {
        window.open(notification.button.link);
      } else {
        this.$router.push(notification.button.link);
      }
    },
    loadPreferenceFromEvent(preferences, event, network_id = null) {
      let existingPreference = preferences.find(p => p.notification_event_id === event.id && p.network_id == network_id);
      let preference = null;
      if (existingPreference) {
        preference = {
          notification_event_id: event.id,
          receive_email: existingPreference.receive_email,
          receive_notification: existingPreference.receive_notification,
          network_id: network_id,
        };
      } else {
        preference = {
          notification_event_id: event.id,
          receive_email: event.receive_email_fallback,
          receive_notification: event.receive_notification_fallback,
          network_id: network_id,
        };
      }
      this.notificationPreferences.push(preference);
    },
    notification_events() {
      let currentNetworkNotificationPreferences = [];
      let networkNotificationMessage = '';
      this.notificationPreferences.forEach(notification => {
        if (notification.network_id == this.network.id) {
          if (notification.notification_event_id == 1 || notification.notification_event_id == 2) {
            currentNetworkNotificationPreferences.push(notification);
          }
        }
      });
      for (let index = 0; index < currentNetworkNotificationPreferences.length; index++) {
        // New media
        if (
          currentNetworkNotificationPreferences[index]['notification_event_id'] == 1 &&
          (currentNetworkNotificationPreferences[index]['receive_email'] == false ||
            currentNetworkNotificationPreferences[index]['receive_notification'] == false)
        ) {
          networkNotificationMessage = this.$t('are-you-missing-out-on-recently-published-media-to-stay-updated-adjust-your-settings');
          return networkNotificationMessage;
        }
        // New media collection
        if (
          currentNetworkNotificationPreferences[index]['notification_event_id'] == 2 &&
          (currentNetworkNotificationPreferences[index]['receive_email'] == false ||
            currentNetworkNotificationPreferences[index]['receive_notification'] == false)
        ) {
          networkNotificationMessage = this.$t('are-you-missing-out-on-recently-published-media-collections-to-stay-updated-adjust-your-settings');
          return networkNotificationMessage;
        }
      }
    },
    notificationColor(icon) {
      if (icon == 'fas fa-video' || icon == 'fas fa-folder-open' || icon == 'fas fa-comment') {
        return '#5a5b75';
      } else {
        return '#005f9a';
      }
    },
    toggleLike() {
      this.busy = true;
      this.$http.post('networks/' + this.network.slug + '/toggle-like').then(resp => {
        if (resp.data == 1) {
          this.is_liked = false;
          // umami tracking for unlike action
          if (window.umami && typeof window.umami.track === 'function') {
            window.umami.track(`unlike-network-${this.network.id}`);
          }
          this.$swal.fire({
            text: this.$t('removed-from-your-liked-networks'),
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          this.busy = false;
        } else {
          this.is_liked = true;
          // umami tracking for like action
          if (window.umami && typeof window.umami.track === 'function') {
            window.umami.track(`like-network-${this.network.id}`);
          }
          this.$swal.fire({
            text: this.$t('added-to-your-liked-networks'),
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          this.busy = false;
        }
      });
    }
  },
};
</script>
<style scoped>
.profile-page .profile-header {
  box-shadow: 0 0 10px 0 rgba(183, 192, 206, 0.2);
  border: 1px solid #f2f4f9;
}
.profile-page .profile-header .cover {
  position: relative;
  border-radius: 0.25rem 0.25rem 0 0;
}
.profile-page .profile-header .cover figure img {
  border-radius: 0.25rem 0.25rem 0 0;
  width: 100%;
}
@media (max-width: 600px) {
  .profile-page {
    padding: 0;
    margin-top: -15px;
  }
  .mobile-icons {
    margin-top: 0.5rem !important;
  }
  .mobile-icons i,
  .mobile-icons span {
    font-size: 1rem;
  }
  .mobile-icons i {
    padding-top: 3px !important;
  }
  .mobile-icons .col-3 {
    justify-content: center;
    display: flex;
  }
}
@media (min-width: 601px) and (max-width: 990px) {
  .mobile-icons i,
  .mobile-icons span {
    font-size: 2rem;
  }
  .mobile-icons .col-3 {
    justify-content: center;
    display: flex;
  }
}
/*
.profile-page .profile-header .cover figure {
  margin-bottom: 0;
}
@media (max-width: 767px) {
  .profile-page .profile-header .cover figure {
    height: 110px;
    overflow: hidden;
  }
}
@media (min-width: 2400px) {
  .profile-page .profile-header .cover figure {
    height: 280px;
    overflow: hidden;
  }
}
@media (max-width: 767px) {
  .profile-page .profile-header .cover figure img {
    -webkit-transform: scale(2);
    transform: scale(2);
    margin-top: 15px;
  }
}
@media (min-width: 2400px) {
  .profile-page .profile-header .cover figure img {
    margin-top: -55px;
  }
} */
.profile-page .profile-header .cover .gray-shade {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgb(0, 0, 0) 450%);
}
.profile-page .profile-header .cover .cover-body {
  position: absolute;
  bottom: 10px;
  left: 20px;
  z-index: 2;
  width: 100%;
  padding: 0 20px;
}
.profile-page .profile-header .cover .cover-body .profile-pic {
  border-radius: 50%;
  width: 100px;
  font-size: 85px !important;
}
/* @media (max-width: 767px) {
  .profile-page .profile-header .cover .cover-body .profile-pic {
    width: 70px;
  }
} */
.profile-page .profile-header .cover .cover-body .profile-name {
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin-left: 17px;
}
.profile-page .profile-header .header-links {
  padding: 15px;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  background: #fff;
  border-radius: 0 0 0.25rem 0.25rem;
}
.profile-page .profile-header .header-links ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.profile-page .profile-header .header-links ul li a {
  color: #000;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.blur {
  color: transparent;
  text-shadow: 0 0 8px #000;
  -webkit-filter: blur(5px);
  filter: blur(5px);
  pointer-events: none !important;
}
.swal2-timer-progress-bar {
  background-color: #198754;
}
</style>